// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__12VQP","location":"Header_location__3Hh7J"};